'use strict'

const actionTypes = {
  'SET_CONTROLLER_CONFIG': 'SET_CONTROLLER_CONFIG',
  'SET_PAGINATION_DATA': 'SET_PAGINATION_DATA'
}

const setConfig = (config) => ({
  type: actionTypes.SET_CONTROLLER_CONFIG,
  config
})

const setPaginationData = (paginationData) => ({
  type: actionTypes.SET_PAGINATION_DATA,
  paginationData
})


module.exports.actionTypes = actionTypes

module.exports.setConfig = setConfig
module.exports.setPaginationData = setPaginationData



// WEBPACK FOOTER //
// ./dataset-controller/actions.js